import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
   border: 2px solid ${(props) => props.theme.primaryLight};
   background-color: ${(props) => props.theme.white};
   border-radius: 6px;
   padding: 8px 10px;
   width: 100%;
   margin: 0;
`;

StyledFieldset.displayName = 'StyledFieldset';

export const StyledFieldsetRadioGroup = styled.div`
   display: flex;
   flex-direction: column;
   gap: 6px;
`;

StyledFieldsetRadioGroup.displayName = 'StyledFieldsetRadioGroup';

export const StyledFieldsetRadioLabel = styled.label`
   display: flex;
   align-items: center;
   gap: 8px;
   font-size: 13px;
   background-color: ${(props) => props.theme.white};
   color: ${(props) => props.theme.textBody};
   cursor: pointer;

   input[type='radio'] {
      cursor: pointer;
   }
`;

StyledFieldsetRadioLabel.displayName = 'StyledFieldsetRadioLabel';
